import React from "react";
import { createRoot } from "react-dom/client";
import { LanguageAccessPanel } from "./LanguageAccessPanel";
import type { LanguageAccessModel } from "./types";

declare global {
  interface Window {
    renderLanguageAccessPanel: (model: LanguageAccessModel) => void;
  }
}

/**
 * Mounts the panel into #language-access-root. Follows the same contract as meetingKiosk: the view
 * loads the bundle, then calls this with the server's JSON blob.
 *
 * The panel is one of several partials on a public meeting page, so a failure here must never take
 * the page with it -- a resident who cannot see the language pills should still be able to read the
 * agenda and register.
 */
window.renderLanguageAccessPanel = function renderLanguageAccessPanel(
  model: LanguageAccessModel
): void {
  const container = document.getElementById("language-access-root");
  if (!container) {
    return;
  }

  try {
    createRoot(container).render(<LanguageAccessPanel model={model} />);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("LanguageAccessPanel failed to mount:", error);
  }
};
